import React from 'react'
import FollowUpTable from '../../templates/FollowUpTable'
import FollowUpTiles from '../../templates/FollowUpTiles'
import Layout from '../../templates/Layout'

const FollowUpMorePage = () => {
  return (
    <Layout>
      <FollowUpTiles title="Seguimiento More" showAll />
      <FollowUpTable showAll />
    </Layout>
  )
}

export default FollowUpMorePage
